// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:18
import { ListNameAction_abstract } from './../abstract/SagaSchema/ListNameAction_abstract';
export class ListNameAction extends ListNameAction_abstract {}
